import type { ModalFuncProps } from 'antd/es/modal/interface';
import type { TFunction } from 'i18next';

import TotpForm from '../../components/Forms/TotpForm';

type ModalConfirm = (props: ModalFuncProps) => { destroy: () => void };

/**
 * Opens the same Two-Factor Authentication modal as the user menu in the header.
 */
export function openTotpFormModal(params: {
  modal: { confirm: ModalConfirm };
  t: TFunction;
  getUserInfo?: () => void | Promise<void>;
}): void {
  const { modal, t, getUserInfo } = params;
  const modalInstance = modal.confirm({
    title: t('modal.totpForm.title'),
    content: (
      <TotpForm
        onClose={() => modalInstance.destroy()}
        onSuccess={() => {
          modalInstance.destroy();
          void getUserInfo?.();
        }}
      />
    ),
    footer: null,
    width: 560,
  });
}
